import { ENUM_APP_NAME } from "@/configs/enums/enum";
import { axiosClient } from "@/configs/helpers/AxiosHelper";
import type { typeGetFile } from "@/configs/types/Shared/typeFile";

export class fetchFile {
  async Get(ids: string[]) {
    try {
      const responses = await Promise.all(
        await ids.map(async (id) => {
          const { data } = await axiosClient({ isFile: false }, ENUM_APP_NAME.TOURIST_POLICE).get<typeGetFile>(`/v1/files/${id}`);
          return data;
        })
      );

      return await responses;
    } catch (error) {
      return [];
    }
  }
  async GetUrl(id: string) {
    try {
      const responses = await axiosClient({ isFile: false }, ENUM_APP_NAME.TOURIST_POLICE).get<typeGetFile>(`/v1/files/${id}`);

      return await (responses.data.url ? responses.data.url : "");
    } catch (error) {
      return null;
    }
  }
  async Upload(files: File[]): Promise<typeGetFile[] | any> {
    if (files.length) {
      const formDataArray = Array.from(files).map((fileItem) => {
        const formData = new FormData();
        formData.append("file", fileItem);
        formData.append("accept", "image/*");
        return formData;
      });

      try {
        const responses = await Promise.all(formDataArray.map((formData) => axiosClient({ isFile: true }, ENUM_APP_NAME.TOURIST_POLICE).post<typeGetFile>("/v1/files", formData)));

        const responseDataArray = await responses.map((response) => response.data);
        return responseDataArray;
      } catch (error) {
        console.error("Error sending files:", error);
        throw error;
      }
    }
  }
}
